export default __webpack_public_path__ + "static/media/hh-web-logo-white.f1d1c112.png";